/**
 * Static Trusted Partner Images used by the home page
 */
const TRUSTED_PARTNERS = {
  image: [
    {
      url: '/assets/img/trustedpartners/hp-axa.svg',
      href: 'https://www.genesys.com/customer-stories/bbva-argentina',
      alt: '',
      width: '98',
      height: '98',
    },
    {
      url: '/assets/img/trustedpartners/hp-bbva.svg',
      href: 'https://www.genesys.com/customer-stories/bbva-argentina',
      alt: '',
      width: '159',
      height: '47',
    },
    {
      url: '/assets/img/trustedpartners/hp-efinancial.svg',
      href: 'https://www.genesys.com/customer-stories/efinancial',
      alt: '',
      width: '227',
      height: '37',
    },
    {
      url: '/assets/img/trustedpartners/hp-quicken.svg',
      href: 'https://www.genesys.com/customer-stories/quicken',
      alt: '',
      width: '183',
      height: '41',
    },
    {
      url: '/assets/img/trustedpartners/hp-singapore.svg',
      href: 'https://www.genesys.com/customer-stories/singapore-airlines',
      alt: '',
      width: '160',
      height: '58',
    },
    {
      url: '/assets/img/trustedpartners/hp-swisscom.svg',
      href: 'https://www.genesys.com/customer-stories/swisscom',
      alt: '',
      width: '183',
      height: '52',
    },
    {
      url: '/assets/img/trustedpartners/hp-vivo.svg',
      href: 'https://www.genesys.com/customer-stories/vivo',
      alt: '',
      width: '159',
      height: '54',
    },
    {
      url: '/assets/img/trustedpartners/hp-vodafone.svg',
      href: 'https://www.genesys.com/customer-stories/vodafone',
      alt: '',
      width: '189',
      height: '46',
    },
    {
      url: '/assets/img/trustedpartners/hp-singapore.svg',
      href: 'https://www.genesys.com/customer-stories/singapore-airlines',
      alt: '',
      width: '160',
      height: '58',
    },
    {
      url: '/assets/img/trustedpartners/hp-vivo.svg',
      href: 'https://www.genesys.com/customer-stories/vivo',
      alt: '',
      width: '159',
      height: '54',
    },
  ],
};

export default TRUSTED_PARTNERS;
